// src/data/plans.js

export const PLANS = [
  { key: "free", label: "Free", priceLabel: "$0", discountLevel: 0, rank: 0 },
  { key: "regular", label: "Regular", priceLabel: "$50", discountLevel: 10, rank: 1 },
  { key: "vip", label: "VIP", priceLabel: "VIP", discountLevel: 15, rank: 2 },
  { key: "ambassador", label: "Ambassador", priceLabel: "Ambassador", discountLevel: 20, rank: 3 },
  { key: "global_a", label: "Global A", priceLabel: "Global A", discountLevel: 25, rank: 4 },
  { key: "global_b", label: "Global B", priceLabel: "Global B", discountLevel: 30, rank: 5 },
];

// quick lookup
const map = new Map(PLANS.map((p) => [p.key, p]));

// ✅ App.jsx + MarketApp.jsx use this
export function getPlan(key = "free") {
  return map.get(key) || map.get("free");
}

// ✅ IMPORTANT: MarketApp.jsx expects planRank to be a FUNCTION (it checks typeof === "function")
export function planRank(key = "free") {
  return getPlan(key)?.rank ?? 0;
}

// ✅ keep this too (optional)
export function getPlanRank(key = "free") {
  return planRank(key);
}
